import { FC } from 'react';
import Button from '../../../components/Button/Button';
import { Variant } from '../../../components/Button/Button.types';
import MaskedInput from '../../../components/MaskedInput/MaskedInput';
import Modal from '../../../components/Modal/Modal';
import { StyledButtons, StyledMessage } from './MultiUpdateUsageAmtModal.styles';
import { MultiUpdateUsageAmtModalProps } from './MultiUpdateUsageAmtModal.types';

const MultiUpdateUsageAmtModal: FC<MultiUpdateUsageAmtModalProps> = ({
  open,
  onClose,
  onSubmit,
  handleChange,
  multiUsageAmountValue,
  errorText,
  isLoading,
}) => {
  return (
    <Modal id='multiUpdateUsageAmtModal' open={open} onClose={onClose} title='Multi Update'>
      <div>
        <StyledMessage>Enter a usage amount to apply to all records.</StyledMessage>
        <MaskedInput
          label='Usage Amount'
          id='usageAmount'
          value={multiUsageAmountValue}
          onValueChange={handleChange}
          errorText={errorText}
        />
        <StyledButtons>
          <Button variant={Variant.Secondary} label='Cancel' onClick={onClose} />
          <Button label='Submit' onClick={onSubmit} isLoading={isLoading} loadingLabel='Submitting...' />
        </StyledButtons>
      </div>
    </Modal>
  );
};

export default MultiUpdateUsageAmtModal;
